// validators.js

// First Accordion Validation - Vehicle Info
// validateVehicleSection;
export const validateVehicleSection = (state) => {
  const errors = {};
  if (!state.fullRegNo || state.fullRegNo.trim() === "") {
    errors.fullRegNo = "Please Enter Vechile Register Number";
  }
  if (!state.business_type || state.business_type.trim() === "") {
    errors.business_type = "Please Select Bussiness Type";
  }

  if (!state.proposer_type || state.proposer_type.trim() === "") {
    errors.proposer_type = "Please Select Proposer Type";
  }
  if (!state.plan_type || state.plan_type.trim() === "") {
    errors.plan_type = "Please Select Plan Type";
  }
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
// Second Accordion Validation - Date Fields
export const validatePolicyDates = (state) => {
  const errors = {};

  if (!state.pol_start_date || state.pol_start_date.trim() === "") {
    errors.pol_start_date = "Policy start date is required.";
  }
  // if (!state.cpa_start_date || state.cpa_start_date.trim() === "") {
  //   errors.cpa_start_date = "CPA start date is required.";
  // }
  
  // if (!state.cpa_end_date || state.cpa_end_date.trim() === "") {
  //   errors.cpa_end_date = "CPA end is required.";
  // }

  if (!state.prev_pol_start_date || state.prev_pol_start_date.trim() === "") {
    errors.prev_pol_start_date = "Previous policy start date is required.";
  }
  if (!state.prev_pol_end_date || state.prev_pol_end_date.trim() === "") {
    errors.prev_pol_end_date = "Previous policy end date is required.";
  }
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

const validationFunctions = {
  validateVehicleSection,
  validatePolicyDates,
};

export default validationFunctions;
// nominee validation

export const getAge = (dob) => {
  const today = new Date();
  const birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
// validateProposerForm.js
export const validateProposerForm = (state) => {
  const errors = {};
  if (!state.proposer_salutation || state.proposer_salutation.trim() === "") {
    errors.proposer_salutation = "Please Select Salutation";
  }
  if (!state.proposer_fname || state.proposer_fname.trim() === "") {
    errors.proposer_fname = "Please Enter Your First Name";
  }

  if (!state.proposer_lname || state.proposer_lname.trim() === "") {
    errors.proposer_lname = "Please Enter Your Last Name";
  }

  if (
    !state.proposer_dob ||
    typeof state.proposer_dob !== "string" ||
    state.proposer_dob.trim() === ""
  ) {
    errors.proposer_dob = "Please Enter Proposer D.O.B";
  }

  if (!state.proposer_gender || state.proposer_gender.trim() === "") {
    errors.proposer_gender = "Please Select Gender";
  }
  if (!state.proposer_occupation || state.proposer_occupation.trim() === "") {
    errors.proposer_occupation = "Please Select Proposer Occupation";
  }

  if (
    !state.proposer_dob ||
    typeof state.proposer_dob !== "string" ||
    state.proposer_dob.trim() === ""
  ) {
    errors.proposer_dob = "Please Enter Proposer D.O.B";
  }

  if (!state.proposer_mobile || state.proposer_mobile.length !== 10) {
    errors.proposer_mobile = "Please Enter Your 10 Digit Mobile Number";
  }

  if (!state.proposer_email || state.proposer_email.trim() === "") {
    errors.proposer_email = "Please Enter Your Email Id";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.proposer_email)) {
    errors.proposer_email = "Please Enter a Valid Email Id";
  }

  if (!state.proposer_add1 || state.proposer_add1.trim() === "") {
    errors.proposer_add1 = "Please Enter Address one";
  }

  if (!state.proposer_add2 || state.proposer_add2.trim() === "") {
    errors.proposer_add2 = "Please Enter Address Two";
  }

  if (!state.proposer_state || state.proposer_state.trim() === "") {
    errors.proposer_state = "Please Enter State";
  }
  if (!state.nominee_name || state.nominee_name.trim() === "") {
    errors.nominee_name = "Please Enter Nominee Name";
  }
  if (!state.nominee_age || state.nominee_age.trim() === "") {
    errors.nominee_age = "Please Enter Nominee Age(in  numbers)";
  }
  if (!state.nominee_relation || state.nominee_relation.trim() === "") {
    errors.nominee_relation = "Please Select Nominee Relation";
  }
  if (!state.vehicle_engine || state.vehicle_engine.trim() === "") {
    errors.vehicle_engine = "Please Enter Vechine Engine No";
  }
  if (!state.vehicle_chassis || state.vehicle_chassis.trim() === "") {
    errors.vehicle_chassis = "Please Enter Vechine Chassis No";
  }
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
